import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_ENDPOINTS, INTEGRATION_TYPES } from '../Constants';

const determineIntegrationType = (apiUrl, apiUserName) => {
    if (apiUrl?.toLowerCase().includes("flex")) {
        return INTEGRATION_TYPES.GAMEFLEX;
    }
    if (apiUrl?.toLowerCase().includes("ogs")) {
        return INTEGRATION_TYPES.OGS;
    }
    if (apiUserName?.startsWith("L0") || apiUserName?.startsWith("P0")) {
        return INTEGRATION_TYPES.GAMEFLEX;
    }
    return INTEGRATION_TYPES.GGI;
};

const useServerData = () => {
    const [serverDetailsList, setServerDetailsList] = useState([]);
    const [marketList, setMarketList] = useState([]);
    const [integrationTypeList, setIntegrationTypeList] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchServerDetails = async () => {
            setLoading(true);
            try {
                const response = await axios.get(API_ENDPOINTS.SERVER_DETAILS);
                const serverData = response.data || [];

                const updatedServerData = serverData.map((server) => ({
                    ...server,
                    IntegrationType: determineIntegrationType(server.APIUrl, server.APIUserName),
                    ServerName: server.ServerName?.trim(),
                    LobbyName: server.LobbyName?.trim(),
                    OperatorName: server.OperatorName?.trim()
                }));

                setServerDetailsList(updatedServerData);

                const uniqueMarketList = Array.from(
                    new Set(updatedServerData.map((server) => server.CasinoSiteID).filter(Boolean))
                );
                setMarketList(uniqueMarketList);

                const uniqueIntegrationTypes = Array.from(
                    new Set(updatedServerData.map((server) => server.IntegrationType).filter(Boolean))
                );
                setIntegrationTypeList(uniqueIntegrationTypes);
            } catch (error) {
                console.error("Error fetching server details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchServerDetails();
    }, []);

    return {
        serverDetailsList,
        marketList,
        integrationTypeList,
        loading
    };
};

export default useServerData;